import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { FundraisingForm } from './FundraisingForm';
import { useAuthorized } from './lib';

export const fundraisingPath = `/artist/:artistId/profile/fundraising`;

export function FundraisingRoute(routeProps: RouteProps) {
  const authorized = useAuthorized();

  return authorized ? (
    <Route {...routeProps} component={FundraisingForm} />
  ) : (
    <Redirect to="/" />
  );
}
